/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
import React from 'react';

import StyledTitle, {
  StyledH1,
  StyledH2,
  StyledH3,
  StyledH4,
  HeroTitle,
  FAQTitle,
  FAQCatTitle,
  FAQCatQuestion,
  FATCatSubTitle,
  GlossaryTitle,
} from './styles';

interface TitleProps {
  children: React.ReactNode;
  as?: any;
  size?: string;
  textStyle?: string;
  fontSize?: string;
  fontFamily?: string;
  fontWeight?: string;
  lineHeight?: string;
  m?: string;
  my?: any;
  mx?: string;
  p?: string;
  py?: string;
  px?: string;
  textAlign?: string;
  maxWidth?: string;
  color?: string;
}

const Title = ({
  children,
  as = 'h1',
  size = '',
  textStyle,
  fontSize,
  fontFamily,
  fontWeight,
  lineHeight,
  m,
  my = '',
  mx,
  p,
  py,
  px,
  textAlign,
  maxWidth,
  color,
}: TitleProps) => (
  <StyledTitle
    as={as}
    size={size}
    textStyle={textStyle}
    fontSize={fontSize}
    fontFamily={fontFamily}
    fontWeight={fontWeight}
    lineHeight={lineHeight}
    textAlign={textAlign}
    maxWidth={maxWidth}
    color={color}
    m={m}
    my={my}
    mx={mx}
    p={p}
    py={py}
    px={px}
  >
    {children}
  </StyledTitle>
);

export default Title;

export const H1 = (props: React.JSX.IntrinsicAttributes & TitleProps) => <Title {...props} as={StyledH1} />;

export const H2 = (props: React.JSX.IntrinsicAttributes & TitleProps) => <Title {...props} as={StyledH2} />;

export const H3 = (props: React.JSX.IntrinsicAttributes & TitleProps) => <Title {...props} as={StyledH3} />;

export const H4 = (props: React.JSX.IntrinsicAttributes & TitleProps) => <Title {...props} as={StyledH4} />;

export const FAQ = (props: React.JSX.IntrinsicAttributes & TitleProps) => <Title {...props} as={FAQTitle} />;

export const FAQCat = (props: React.JSX.IntrinsicAttributes & TitleProps) => <Title {...props} as={FAQCatTitle} />;

export const FAQQuestion = (props: React.JSX.IntrinsicAttributes & TitleProps) => <Title {...props} as={FAQCatQuestion} />;

export const FATCatSub = (props: React.JSX.IntrinsicAttributes & TitleProps) => <Title {...props} as={FATCatSubTitle} />;

export const Glossary = (props: React.JSX.IntrinsicAttributes & TitleProps) => <Title {...props} as={GlossaryTitle} />;

export const Hero = (props: React.JSX.IntrinsicAttributes & TitleProps) => <Title {...props} as={HeroTitle} my={[4]} />;
